// Tutoriales in-app — posición de la tarjeta junto al elemento resaltado,
// sin salirse de la ventana. Módulo puro (sin React ni Firebase) para probarlo.
import type { TutorialPlacement } from "./types";

export const GAP = 14; // distancia entre el elemento y la tarjeta
export const CARD_W = 380;

export interface Rect {
  top: number;
  left: number;
  width: number;
  height: number;
}

/** Posición de la tarjeta junto al elemento, sin salirse de la ventana. */
export function cardPosition(rect: Rect | null, placement: TutorialPlacement, cardH: number) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  if (!rect || placement === "center") {
    return { top: Math.max(16, Math.min((vh - cardH) / 2, vh - cardH - 16)), left: Math.max(16, (vw - CARD_W) / 2) };
  }
  const fits = {
    bottom: rect.top + rect.height + GAP + cardH < vh,
    top: rect.top - GAP - cardH > 0,
    right: rect.left + rect.width + GAP + CARD_W < vw,
    left: rect.left - GAP - CARD_W > 0,
  };
  const order: Exclude<TutorialPlacement, "auto" | "center">[] =
    placement === "auto" ? ["bottom", "right", "top", "left"] : [placement, "bottom", "right", "top", "left"];
  const side = order.find((s) => fits[s]) || "bottom";
  const clampX = (x: number) => Math.min(Math.max(16, x), vw - CARD_W - 16);
  const clampY = (y: number) => Math.max(16, Math.min(y, vh - cardH - 16));
  switch (side) {
    case "bottom":
      return { top: clampY(rect.top + rect.height + GAP), left: clampX(rect.left) };
    case "top":
      return { top: clampY(rect.top - GAP - cardH), left: clampX(rect.left) };
    case "right":
      return { top: clampY(rect.top), left: clampX(rect.left + rect.width + GAP) };
    case "left":
      return { top: clampY(rect.top), left: clampX(rect.left - GAP - CARD_W) };
  }
}
